import { useSelector } from 'react-redux'
import { createDefaultRoutesSelector } from '../store/preferences'
import routes from '../routes'

export default function useNamedRoute(routeName, options) {
  const defaults = useSelector(createDefaultRoutesSelector(routeName))
  const route = routes[routeName]

  if (options) {
    return route(options)
  }

  return defaults ? route(defaults) : route()
}
